export default function Footer() {
  return (
    <footer className="bg-[#2C3E50] text-gray-300">
      {/* Top Section */}
      <div className="border-b border-gray-600">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-center md:text-left">
              <div className="flex items-center gap-3 justify-center md:justify-start mb-3">
                <img src="https://public.readdy.ai/ai/img_res/84f3cf5c-8dc2-4cf9-81a4-c926f10f38b5.png" alt="ロゴ" className="w-10 h-10 object-contain" />
                <span className="text-xl font-bold text-white">ホームホワイトニング｜BELL</span>
              </div>
              <p className="text-sm text-gray-400 max-w-md">
                歯科医師監修の医療用ホワイトニングを、<br />自宅で安心してご利用いただけます。
              </p>
            </div>
            
            <div className="text-center">
              <p className="text-base text-white mb-4">まずは無料相談から始めませんか？</p>
              <a
                href="https://lin.ee/voFYYoK"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-[#00C853] text-white font-bold rounded-lg hover:bg-[#00B248] transition-colors flex items-center gap-2 mx-auto whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill"></i>
                LINEで相談
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h4 className="text-base font-bold text-gray-200 mb-4">サービスについて</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-sm hover:text-[#4A90E2] transition-colors cursor-pointer">特徴</a></li>
              <li><a href="#steps" className="text-sm hover:text-[#4A90E2] transition-colors cursor-pointer">ご利用の流れ</a></li>
              <li><a href="#pricing" className="text-sm hover:text-[#4A90E2] transition-colors cursor-pointer">料金プラン</a></li>
              <li><a href="#faq" className="text-sm hover:text-[#4A90E2] transition-colors cursor-pointer">よくある質問</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold text-gray-200 mb-4">SNS</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center hover:bg-[#4A90E2] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center hover:bg-[#4A90E2] transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center hover:bg-[#4A90E2] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-gray-600">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2025 ホームホワイトニング｜BELL. All rights reserved.</p>
            <p>医療機関届出番号：第XXXXX号</p>
          </div>
        </div>
      </div>
    </footer>
  );
}